module.exports = __webpack_public_path__ + "static/media/12.081.df5f70c8.webp";